// Package
import { Component } from "react";
import { Link, Redirect, withRouter } from "react-router-dom";
import { connect } from "react-redux";

// views
import SuperAdminDashboard from "../superAdmin/superAdminDashboard";
import { Avatar, CircularProgress, Paper } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
// Services
import userService from "../../services/user.service";

// Assets
import ErrorMessage from "../../Common/ErrorMessage";
import { DataGrid } from "@mui/x-data-grid";
import SchoolStatus from "../schoolAdminPortal/SchoolAdminPages/SchoolStatus/SchoolStatus";
import DeleteDialog from "../schoolAdminPortal/Popups/DeleteDialog";
import ConfirmPopup from "../schoolAdminPortal/Popups/ConfirmPopup";
import CustomSearch from "../../Common/CustomSearch";
import DeleteIcon from "@mui/icons-material/Delete";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import KeyIcon from "@mui/icons-material/Key";
import ListMenu from "../../Common/ListMenu";
import RestoreIcon from "@mui/icons-material/Restore";
import { getFromLocalStorage } from "../../utils/webStorage";
import PageNotFoundPage from "../../Common/PageNotFoundPage";
import {
  openFailDialog,
  openSuccessPopup,
} from "../../Redux/Actions/PopupActions";
class Schools extends Component {
  constructor() {
    super();
    this.state = {
      allSchoolList: [],
      total: null,
      open: false,
      modalId: "",
      submitting: false,
      search: false,
      redirect: false,
      currentRowId: "",
      pageState: {
        isLoading: false,
        data: [],
        total: 0,
        page: 0,
        pageSize: 10,
      },
      searchQuery: "",
      deletePopup: false,
      currentAthleteId: "",
      msg: "",
      resetPopup: false,
      emailAddress: "",
      redirectToRow: false,
      currentRowId: "",
      searchedRecord: false,
      recordNotFound: false,
      navigateToRedirect: false,
      redirectId: "",
      adminRole: getFromLocalStorage("loginRole"),
      user: JSON.parse(getFromLocalStorage("user")),
    };
  }

  componentDidMount() {
    const school = document.getElementById("Schools");
    if (school) {
      school.classList.add("active");
    }

    this.getSchoolByPage(
      this.state.pageState.page,
      this.state.pageState.pageSize
    );
  }

  getSchoolByPage = (page, size) => {
    const { setFailPopUpInformation } = this.props;
    this.setState({
      pageState: { ...this.state.pageState, isLoading: true },
      submitting: true,
    });
    const data = userService.getSchoolsByPage(page, size);
    data
      .then((res) => {
        //to filter out super admin as school
        let schoolData = res.data.data.schools.filter(
          (ele) => ele?.email != this.state.user.userProfile?.email
        );
        let total =
          schoolData.length == res.data.data.schools.length
            ? res.data.data.total
            : res.data.data.total - 1;
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: schoolData,
            isLoading: false,
            total: total,
            page: page,
          },
          submitting: false,
        });
      })
      .catch((err) => {
        this.setState({ submitting: false });
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  deleteSchool() {
    const ids = this.state.modalId;
    const { setFailPopUpInformation, setSuccessPopupInformation } = this.props;
    const id = {
      schoolId: ids,
    };
    userService
      .deleteSchoolId(id)
      .then((response) => {
        if (response.status === 200) {
          setSuccessPopupInformation({
            successPopUp: {
              message: "School Removed Successfully",
              open: true,
            },
          });
        } else {
          setFailPopUpInformation({
            open: true,
            message: "Something Went Wrong",
          });
        }
      })
      .catch((error) => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  }

  deleteAthleteDialog = (data) => {
    this.setState({
      deletePopup: true,
      msg: "Are You Sure You Want To Delete This School?",
      currentAthleteId: data.id,
    });
  };

  closeAthleteDeleteDialog = () => {
    this.setState({ deletePopup: false });
  };

  deleteCurrentAthlete = () => {
    const { searchedRecord, searchQuery, pageState } = this.state;
    const { setFailPopUpInformation, setSuccessPopupInformation } = this.props;
    this.deleteAthleteUsingId()
      .then(() => {
        this.setState({
          deletePopup: false,
        });
        setSuccessPopupInformation({
          successPopUp: {
            message: "School deleted successfully",
            open: true,
          },
        });
        if (searchedRecord) {
          this.searchCoaches(searchQuery, pageState.page, 10);
        } else {
          this.getSchoolByPage(pageState.page, 10);
        }
      })
      .catch((err) => {
        this.setState({
          deletePopup: false,
        });
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  deleteAthleteUsingId = () => {
    const id = {
      schoolId: this.state.currentAthleteId,
    };
    return userService.deleteSchoolId(id);
  };

  closeResetDialog = () => {
    this.setState({ resetPopup: false });
  };

  sendResetLink = (data) => {
    const obj = {
      email: data.email,
    };
    const { setFailPopUpInformation, setSuccessPopupInformation } = this.props;
    userService
      .resetSchoolLink(obj)
      .then((res) => {
        if ((res.status == 200) & (res.data.success == true)) {
          this.setState({
            resetPopup: false,
          });
          setSuccessPopupInformation({
            successPopUp: {
              message: "Reset Password link sent successfully",
              open: true,
            },
          });
        } else {
          this.setState({
            resetPopup: false,
          });
          setFailPopUpInformation({
            open: true,
            message: "Something Went Wrong",
          });
        }
      })
      .catch((err) => {
        this.setState({
          resetPopup: false,
        });
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  openDialogResetPassword = (email) => {
    this.setState({ emailAddress: email, resetPopup: true });
  };

  setSearchQuery = (value) => {
    this.setState({ searchQuery: value });
  };

  setSearchedRecord = (value) => {
    this.setState({ searchedRecord: value });
  };

  searchCoaches = (query, page, size) => {
    const { schoolId, searchedRecord } = this.state;
    this.setState({
      pageState: { ...this.state.pageState, isLoading: true },
      searchQuery: query,
    });
    if (!searchedRecord) {
      this.setState({ searchedRecord: true });
    }
    userService
      .searchSchool(query, page, size)
      .then((res) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: res.data.data.schools,
            isLoading: false,
            total: res.data.data.total,
            page: page,
          },
          recordNotFound: res.data.data.schools.length == 0 ? true : false,
        });
      })
      .catch((err) => {
        this.setState({
          pageState: {
            ...this.state.pageState,
            data: [],
            isLoading: false,
            total: 0,
            page: page,
          },
          recordNotFound: true,
        });
      });
  };

  setRecordNotFound = () => {
    this.setState({ recordNotFound: false });
  };

  menuItemContent = (data) => {
    const notDeleted = [
      {
        id: "1",
        name: "Edit Details",
        icon: <ModeEditIcon className="manage-section-iconss" />,
        ApiCall: this.redirectToEdit,
      },
      {
        id: "2",
        name: "Reset Password",
        icon: <KeyIcon className="manage-section-iconss" />,
        ApiCall: this.openDialogResetPassword,
      },
      {
        id: "3",
        name: "Delete",
        icon: <DeleteIcon className="manage-section-iconss delete-icon" />,
        ApiCall: this.deleteAthleteDialog,
      },
    ];

    const deleted = [
      {
        id: "1",
        name: "Recover Account",
        icon: <RestoreIcon className="manage-section-iconss" />,
        ApiCall: this.handleRestoreSchool,
      },
    ];
    return data.user.deleted ? deleted : notDeleted;
  };

  redirectToEdit = (data) => {
    this.setState({ navigateToRedirect: true, redirectId: data.id });
  };

  handleRestoreSchool = (data) => {
    const id = {
      schoolId: data.id,
    };
    const { searchedRecord, searchQuery, pageState } = this.state;
    const { setFailPopUpInformation, setSuccessPopupInformation } = this.props;
    userService
      .restoreSchool(id)
      .then((res) => {
        setSuccessPopupInformation({
          successPopUp: {
            message: "Recover Link Sent On Registered Email Id",
            open: true,
          },
        });
        if (searchedRecord) {
          this.searchCoaches(searchQuery, pageState.page, 10);
        } else {
          this.getSchoolByPage(pageState.page, 10);
        }
      })
      .catch((err) => {
        setFailPopUpInformation({
          open: true,
          message: "Something Went Wrong",
        });
      });
  };

  render() {
    const {
      submitting,
      redirect,
      currentRowId,
      pageState,
      searchQuery,
      deletePopup,
      msg,
      resetPopup,
      emailAddress,
      redirectToRow,
      searchedRecord,
      recordNotFound,
      redirectId,
      navigateToRedirect,
      adminRole,
    } = this.state;
    const { history } = this.props;
    if (redirect) {
      return <Redirect to={`/schoolnamescreen/${currentRowId}`} />;
    }

    if (redirectToRow) {
      history.push(`/schoolnamescreen/${currentRowId}`);
    }

    if (navigateToRedirect) {
      history.push(`/editschooldetails/${redirectId}`);
    }

    const tableColumns = [
      {
        field: "schoolName",
        headerName: "School Name",
        headerAlign: "center",
        headerClassName: "table-header bold",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <div className="d-flex-align-cent height-70 w-100 padding-left-10 padding-right-10">
              <p className="link-blue text-width-auto mg-auto">
                {params.row.schoolName}
              </p>
            </div>
          );
        },
      },
      {
        field: "signUpDate",
        headerName: "Signup-Date",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        align: "center",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <div>
              <p>{params.row.signUpDate}</p>
            </div>
          );
        },
      },
      {
        field: "state",
        headerName: "State",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        align: "center",
        headerAlign: "center",
        renderCell: (params) => (
          <div className="d-flex-align-cent height-70 w-100">
            <p className="text-width-auto mg-auto">{params.row.state}</p>
          </div>
        ),
      },
      {
        field: "country",
        headerName: "Country",
        flex: 1,
        minWidth: 150,
        headerClassName: "table-header bold",
        align: "center",
        headerAlign: "center",
      },
      {
        field: "phoneNumber",
        headerName: "Phone Number",
        flex: 1,
        minWidth: 200,
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "email",
        headerName: "Email",
        headerClassName: "table-header bold",
        headerAlign: "center",
        align: "center",
        flex: 1,
        minWidth: 250,
      },
      {
        field: "status",
        headerName: "Status",
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index",
        align: "center",
        flex: 1,
        minWidth: 150,
        headerAlign: "center",
        sortable: false,
        renderCell: (params) => (
          <SchoolStatus
            status={params.row.status}
            isDeleted={params.row.user.deleted}
          />
        ),
      },
      {
        headerClassName: "table-header bold",
        cellClassName: "mng-z-index2",
        headerAlign: "center",
        align: "center",
        sortable: false,
        height: 100,
        renderCell: (params) => (
          <div>
            <ListMenu
              menuContent={this.menuItemContent(params.row)}
              rowData={params.row}
            />
          </div>
        ),
      },
    ];

    return (
      <>
        {adminRole === "SUPER ADMIN" ? (
          <div>
            <SuperAdminDashboard />
            <div className="content-layout pt-20">
              <div className="mng-header stickyy">
                <h4 className="fs-24 bold mob-hd">
                  SCHOOLS ({pageState ? pageState.total : "0"})
                </h4>
                <Link to="/add-school">
                  <button className="addBtnn2 mng-padding">
                    <AddIcon className="mx-1 addIconSc " />
                    ADD SCHOOL
                  </button>
                </Link>
              </div>
              {submitting && (
                <div className="content-layout-loading-animation">
                  <CircularProgress sx={{ fontSize: 10, color: "#002244" }} />
                </div>
              )}
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr">
                {!pageState.data.length > 0 &&
                  !submitting &&
                  !recordNotFound && <ErrorMessage />}
                {!submitting &&
                  (pageState.data.length > 0 || recordNotFound) && (
                    <Paper className="pad-top-20">
                      <CustomSearch
                        searchQuery={searchQuery}
                        setSearchQuery={this.setSearchQuery}
                        setSearchedRecord={this.setSearchedRecord}
                        searchedRecord={searchedRecord}
                        getDataByPage={this.getSchoolByPage}
                        pageState={pageState}
                        searchData={this.searchCoaches}
                        setRecordNotFound={this.setRecordNotFound}
                      />
                      <DataGrid
                        rows={pageState.data}
                        rowCount={pageState.total}
                        loading={pageState.isLoading}
                        pagination
                        page={pageState.page}
                        columns={tableColumns}
                        pageSize={pageState.pageSize}
                        rowsPerPageOptions={[10]}
                        paginationMode="server"
                        onPageChange={(newPage) => {
                          if (searchQuery == "") {
                            this.getSchoolByPage(newPage, 10);
                          } else {
                            this.searchCoaches(searchQuery, newPage, 10);
                          }
                          this.setState({ ...pageState, page: newPage });
                        }}
                        onPageSizeChange={(newPageSize) =>
                          this.setState({
                            ...pageState,
                            pageSize: newPageSize,
                          })
                        }
                        sx={{
                          color: "black",
                          fontFamily: "Rajdhani-SemiBold",
                          fontSize: "18px",
                          backgroundColor: "white",
                          borderBottomLeftRadius: "12px",
                          borderBottomRightRadius: "12px",
                        }}
                        onCellClick={(param) => {
                          this.setState({
                            redirectToRow: true,
                            currentRowId: param.row.id,
                          });
                        }}
                        disableSelectionOnClick
                        autoHeight
                        disableColumnMenu
                        getRowHeight={() => "auto"}
                      />
                    </Paper>
                  )}
                <div className="clear20" />
              </div>

              <DeleteDialog
                open={deletePopup}
                closeDialog={this.closeAthleteDeleteDialog}
                deleteRecord={this.deleteCurrentAthlete}
                deleteId={null}
                msg={msg}
              />

              <ConfirmPopup
                open={resetPopup}
                closeDialog={this.closeResetDialog}
                sendResetLink={this.sendResetLink}
                email={emailAddress}
              />
            </div>
          </div>
        ) : (
          <PageNotFoundPage />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    setFailPopUpInformation: (obj) => openFailDialog(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    state,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Schools)
);
